import { FaAlignLeft } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";

import { toggleShow } from "../../sotre/redux/features/toggleMenuSlice";
import { useEffect } from "react";
import { getApi } from "../../services/api/globalApi";
import { handleUsers, usersState } from "../../sotre/redux/features/userSlice";
import Profile from "./sub-components/profile/Profile";
import Theme from "./sub-components/theme/Theme";

export default function Header() {
  const dispatch = useDispatch();

  const { users } = useSelector(usersState);
  const getUser = async () => {
    try {
      const path = "admin/users/me";
      const response = await getApi({ path });
      dispatch(handleUsers(response?.data?.result));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUser();
  }, []);

  return (
    <div className="sticky p-4 w-full top-0 z-10">
      <div className="flex w-full h-16 justify-between drop-shadow-md shadow-md flex items-center bg-white/50 backdrop-blur-sm dark:bg-[#060d26]/50 justify-end px-6 transition-all ease-linear rounded-3xl">
        <Profile users={users} />
        <div className="flex justify-cnter items-center gap-x-1">
          <FaAlignLeft
            onClick={() => dispatch(toggleShow())}
            size={26}
            className="lg:hidden text-gray-600 dark:text-white cursor-pointer"
          />
          <Theme />
        </div>
      </div>
    </div>
  );
}
